import { render, staticRenderFns } from "./NoAccess.vue?vue&type=template&id=426916be&scoped=true&"
import script from "./NoAccess.vue?vue&type=script&lang=js&"
export * from "./NoAccess.vue?vue&type=script&lang=js&"
import style0 from "./NoAccess.vue?vue&type=style&index=0&id=426916be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426916be",
  null
  
)

export default component.exports